import { createHash } from 'crypto'

export const jsonObjectToHash = (json: unknown): string => (
  createHash('sha256')
    .update(JSON.stringify(json))
    .digest('hex')
)
